import { chartPanel } from '@/pages/dashboard/components/dashboardTheme'

export function DashboardChartEmpty({ message }: { message: string }) {
	return (
		<div className={`${chartPanel} flex h-[280px] flex-col items-center justify-center text-center`}>
			<i className="ri-bar-chart-grouped-line mb-3 text-3xl text-muted-foreground/60" aria-hidden />
			<p className="max-w-xs text-sm font-medium text-muted-foreground">{message}</p>
		</div>
	)
}
